import { AnalysisItem } from '../types';

/**
 * Вычисляет вердикт анализа на основе items
 * @param items Массив элементов анализа
 * @returns 'YES' | 'NO' | 'MAYBE'
 */
export function calculateVerdict(items: AnalysisItem[]): 'YES' | 'NO' | 'MAYBE' {
  const plusItems = items.filter(item => item.category === 'plus');
  const minusItems = items.filter(item => item.category === 'minus');
  
  const totalPlusScore = plusItems.reduce((sum, item) => sum + item.rating, 0);
  const totalMinusScore = minusItems.reduce((sum, item) => sum + item.rating, 0);
  
  if (totalPlusScore > totalMinusScore) return 'YES';
  if (totalMinusScore > totalPlusScore) return 'NO';
  return 'MAYBE';
}

/**
 * Возвращает ключ i18n для подписи вердикта (analysis.verdictYes / verdictNo / verdictMaybe).
 * API и бэкенд отдают ДА/НЕТ/50/50; внутренний формат — YES/NO/MAYBE.
 */
export function getVerdictI18nKey(verdict: string): 'verdictYes' | 'verdictNo' | 'verdictMaybe' | null {
  if (verdict === 'ДА' || verdict === 'YES') return 'verdictYes';
  if (verdict === 'НЕТ' || verdict === 'NO') return 'verdictNo';
  if (verdict === '50/50' || verdict === 'MAYBE') return 'verdictMaybe';
  return null;
}

